import * as dateFns from "https://cdn.skypack.dev/date-fns@2.28.0";

function shippingDate() {
  const productShippingDate = document.querySelector("#productShippingDate");

  if(productShippingDate) {

    let today = dateFns.set(new Date(), { hours: 0, minutes: 0, seconds: 0 }),
        shippingDays = productShippingDate.dataset.shippingDate,
        shippingDate = dateFns.addDays(today, shippingDays);

    productShippingDate.textContent = dateFns.format(shippingDate, 'M月d日');
  }
}

document.addEventListener("DOMContentLoaded", () => {
  shippingDate();
});